import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import showRegistrationClosedAlert from "../utils/registrationClosedAlert.js";
import "../style/program.css";
import DividerProgram from "../assets/images/dividerProgram.svg";

const Programpage = ({ setLocation, setOverlayMonthly, formStatus }) => {
  const address = useLocation();
  const navigate = useNavigate();

  // Formulir bisa ditutup admin lewat Dashboard Admin. Kalau ditutup, tombol
  // Register Now hanya menampilkan info kelas penuh + link waiting list.
  const handleRegister = (form, path) => {
    if (formStatus && formStatus[form]) {
      showRegistrationClosedAlert();
      return;
    }
    navigate(path);
  };

  useEffect(() => {
    setLocation(address);
  }, []);
  return (
    <main>
      <div className="custom-con1-program align-items-center position-relative">
        <div className="custom-content-section1-program position-absolute top-50 start-50">
          <p className="custom-text1-section1-program">
            We’ll help you in finding the best program and support in this
            journey.
          </p>
          <button
            className="custom-btn-section1-program"
            onClick={() => window.open("https://wa.me/628984001333", "_blank")}
          >
            Talk To Us
          </button>
        </div>
      </div>
      <div className="custom-con2-program position-relative d-flex justify-content-center align-items-center">
        <img
          className="custom-divider-programs position-absolute top-0 start-0 z-1"
          src={DividerProgram}
          alt="divider.svg"
        />
        <div className="custom-content-section2-program position-relative">
          <div className="row align-items-center m-0 d-flex justify-content-center align-items-center">
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 me-md-2 me-lg-2 me-xl-2 me-xxl-2 custom-size-col-section2-programs">
              <p className="custom-text1-section2-program">1 Year Program</p>
              <p className="custom-text2-section2-program">879.900/month </p>
              <p className="custom-text3-section2-program">
                (9x installment with down payment) Dinner & Tax included.{" "}
              </p>
              <ul className="custom-text4-section2-program">
                <li className="my-1">10 Courses</li>
                <li className="my-1">
                  IFGF Conference / IFGF Leadership Conference
                </li>
                <li className="my-1">Academy Graduation</li>
                <li className="my-1">Exclusive CEA T-Shirt</li>
                <li className="my-1">Student Package</li>
              </ul>
              <button
                className="custom-btn-section2-program"
                onClick={() => handleRegister("yearly", "/registeryearly")}
              >
                Register Now
              </button>
            </div>
            <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 ms-md-2 ms-lg-2 ms-xl-2 ms-xxl-2 custom-size-col-section2-programs">
              <p className="custom-text1-section2-program">1 Month Course</p>
              <p className="custom-text2-section2-program">1.050.000/month </p>
              <p className="custom-text3-section2-program">
                Dinner & Tax included
              </p>
              <ul className="custom-text4-section2-program">
                <li className="my-1">One-time Class</li>

                <li className="my-1">Student Package</li>
              </ul>
              <button
                className="custom-btn-section2-program"
                onClick={() => handleRegister("monthly", "/registermonthly")}
              >
                Register Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Programpage;
